export default __webpack_public_path__ + "static/media/2241.b67969ab.png";